import { render, staticRenderFns } from "./tradingMarket.vue?vue&type=template&id=df18d2d4&scoped=true"
import script from "./tradingMarket.vue?vue&type=script&lang=js"
export * from "./tradingMarket.vue?vue&type=script&lang=js"
import style0 from "./tradingMarket.vue?vue&type=style&index=0&id=df18d2d4&prod&lang=less&scoped=true"
import style1 from "./tradingMarket.vue?vue&type=style&index=1&id=df18d2d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_yhenekn6hnf4pbbtdhpnebbsqm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df18d2d4",
  null
  
)

export default component.exports